import React, {useState} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './SizedImage.scss';

const SizedeImage = ({onLoaded, shadow, direct, fitRatio, alt, rel, src, className, width, height}) => {
  const [loaded, setLoaded] = useState(false);

  const showImage = () => {
    setLoaded(true);
    if (onLoaded) onLoaded();
  };

  const style = {};
  if (fitRatio) style.height = '100%';

  // Add size to src
  let parsedSrc = src;
  if (width || height) {
    const slash = src.lastIndexOf('/');
    const start = src.substring(0, slash);
    const end = src.substring(slash + 1);
    const size = '/' + (width ? width : '9999') + 'x' + (height ? height : '9999') + '/';
    parsedSrc = start + size + end;
  }

  return (
    <img
      className={classNames('my-image', className, {loaded: loaded || direct, shadow})}
      onLoad={showImage}
      alt={alt}
      rel={rel}
      src={parsedSrc}
      style={style}
    />
  );
};

SizedeImage.prototypes = {
  alt: PropTypes.string.isRequired,
};

export default SizedeImage;
